<template>
    <div class="eli-pingan px-5 pb-3">

        <div slot="header" class="app-form__hd align-middle py-2">
            <el-form>
                <el-form-item>
                    <el-button size="small" @click="cancelData">返回</el-button>
                    &nbsp;
                    <el-button type="primary" size="small" @click="handleExport('pdf')">导出PDF</el-button>
                    &nbsp;
                    <!-- <el-button type="primary" size="small" @click="handleExport('word')">导出Word</el-button> -->
                    &nbsp;
                    <el-button type="primary" size="small" @click="handleSave()">保存并提交</el-button>
                </el-form-item>
            </el-form>
        </div>

        <h2 class="text-center">沿海内河船舶第三者责任保险投保单</h2>
        <table class="af-table eli-pingan-table">
            <tr>
                <td colspan="8">
                    <p class="font-weight-bold af-cell pt-3">
                        在您填写本投保单前，请仔细阅读《沿海内河船舶第三者责任保险条款》，特别注意条款中有关保险责任、免除保险人责任和投保人、被保险人义务的规定，同时听取保险人就条款所做的说明，并可就其中内容要求保险人做出解释。在您已充分理解保险条款后，请您用黑色或蓝黑色笔如实填写本投保单并签章确认。
                    </p>
                </td>
            </tr>
            <tr>
                <td colspan="8">
                    <label class="font-weight-bold">投保情况</label>
                    <el-radio-group v-model="form.activity_type">
                        <el-radio :label="1">新投保业务</el-radio>
                        <el-radio :label="2">续保业务</el-radio>
                    </el-radio-group>

                    <span class="mr-2"></span>（上年保险单号：
                    <el-input size="mini" v-model="form.policy_number" class="no-border w-50"></el-input>
                    )

                </td>
            </tr>
            <tr>
                <td rowspan="4">
                    <label class="text-center">投保人</label>
                </td>
                <td>
                    <label class="text-center">名称</label>
                </td>
                <td colspan="5">
                    <el-input v-model="form.applicant_name" class="no-border"></el-input>
                </td>
            </tr>
            <tr>
                <td>
                    <label>地址</label>
                </td>
                <td colspan="5">
                    <el-input v-model="form.applicant_address" class="no-border"></el-input>
                </td>
            </tr>
            <tr>
                <td>
                    <label>联系人/电话</label>
                </td>
                <td colspan="6">
                    <el-input v-model="form.applicant_mobile" class="no-border"></el-input>
                </td>
            </tr>
            <tr>
                <td>
                    <label>邮编</label>
                </td>
                <td colspan="3">
                    <el-input v-model="form.applicant_code" class="no-border"></el-input>
                </td>
                <td>
                    <label>传真</label>
                </td>
                <td colspan="3">
                    <el-input v-model="form.applicant_fax" class="no-border"></el-input>
                </td>
            </tr>
            <tr>
                <td rowspan="5">
                    <label>被保险人</label>
                </td>
            </tr>
            <tr>
                <td><label>名称</label></td>
                <td colspan="2">
                    <el-input v-model="form.insured" class="no-border" disabled ></el-input>
                </td>

                <td><label>法人登记证</label></td>
                <td colspan="2">
                    <el-input v-model="form.insured_certificate" class="no-border"></el-input>
                </td>
            </tr>
            <tr>
                <td><label>地址</label></td>
                <td colspan="2">
                    <el-input v-model="form.insured_address" class="no-border"></el-input>
                </td>

                <td><label>邮政编码</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" v-model="form.insured_code"></el-input>
                </td>
            </tr>
            <tr>
                <td><label>联系人/电话</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" v-model="form.insured_mobile"></el-input>
                </td>
                <td><label>传真</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" v-model="form.insured_fax"></el-input>
                </td>
            </tr>
            <tr>
                <td><label>拥有船舶数量及种类及出险情况</label></td>
                <el-input size="mini" class="no-border" v-model="form.insured_count"></el-input>
            </tr>
            <tr>
                <td rowspan="7">
                    <label>投保标的信息</label>
                </td>
            </tr>
            <tr>
                <td><label>船舶名称</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.ship_name"></el-input>
                </td>
                <td><label>船舶类型</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.ship_type"></el-input>
                </td>
            </tr>
            <tr>
                <td><label>船舶建造地点</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" aria-readonly="true"></el-input>
                </td>
                <td><label>船舶建造年月</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.construct_date">
                    </el-input>
                </td>
            </tr>
            <tr>
                <td><label>船舶改造地点/年月</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" aria-readonly="true"></el-input>
                </td>
                <td><label>船籍港</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.reg_port"></el-input>
                </td>
            </tr>
            <tr>
                <td><label>船级</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" aria-readonly="true"></el-input>
                </td>
                <td><label>航行范围</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.airworthiness_area">
                    </el-input>
                </td>
            </tr>
            <tr>
                <td><label>总吨位</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" aria-readonly="true" v-model="form.pay_gross_ton">
                    </el-input>
                </td>
                <td><label>载重吨位</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" aria-readonly="true"></el-input>
                </td>
            </tr>
            <tr>
                <td>
                    <label>近三年的损失记录（时间、原因、损失金额）</label>
                </td>
                <td colspan="7">
                    <el-input size="mini" class="no-border" aria-readonly="true">
                    </el-input>
                </td>
            </tr>


            <tr>
                <td rowspan="6">
                    <label>保险条件</label>
                </td>
            </tr>
            <tr>
                <td><label>每次事故赔偿限额</label></td>
                <td colspan="2">
                    <el-input size="mini" class="no-border" v-model="form.compensate"></el-input>
                </td>
                <td><label>累计赔偿限额</label></td>
                <td colspan="3">
                    <el-input size="mini" class="no-border" v-model="form.compensates"></el-input>
                </td>
            </tr>
            <tr>
                <td class="text-center">
                    <label>请在需要投保的责任前□打“√”或者涂黑</label>
                </td>
                <td colspan="7">
                    <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 20 }" class="no-border"
                        v-model="form.agreement"></el-input>
                </td>
            </tr>
            <tr>
                <td class="text-center">
                    <label>总保费及保险费交付日期</label>
                </td>
                <td colspan="7">
                    <el-input class="no-border" v-model="form.account"></el-input>
                </td>
            </tr>
            <tr>
                <td>
                    <label>保险期间</label>
                </td>
                <td colspan="7">
                    <el-input class="no-border" v-model="form.period"></el-input>
                </td>
            </tr>

            <tr>
                <td class="text-center">
                    <label>特别约定</label>
                </td>
                <td colspan="5">
                    <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 20 }" v-model="form.payment_agreement">
                    </el-input>
                </td>
            </tr>
            <tr>
                <td colspan="8">
                    <p class="font-weight-bold af-cell pt-3">
                        投保人声明：保险人已向本人交付《沿海内河船舶第三者责任保险条款》，并详细介绍了条款内容，特别是对保险合同中免除保险人责任的条款和投保人、被保险人义务的内容做了明确说明，本人已知悉其涵义，同意投保并以此投保单作为订立保险合同的依据。
                    </p>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="af-cell">
                    经办人：
                </td>
                <td colspan="2" class="af-cell">
                    复核人：
                </td>
                <td colspan="2" class="af-cell">
                    投保人签章：
                </td>
                <td colspan="2" class="af-cell">
                    <el-input class="no-border" v-model="form.date"></el-input>
                </td>
            </tr>
        </table>


    </div>
</template>
  
<script>

import { GetActivityInfo, GetShipInfo, exportAppForm, saveAppform,smallPolicy} from '@/api/group-insurance'


export default {
    name: "smallDetail",
    components: {
    },
    computed: {

    },
    data() {
        return {
            opera_type:"",
            radio:'1',
            form: {
                id: "",
                template: 'SmallAppForm',
                file_type: '',
                payment_agreement: "",
                activity_type: 1,
                applicant_name: "",
                policy_number: "",
                applicant_mobile: "",
                applicant_code: "",
                applicant_fax: "",
                applicant_address: "",
                insured_name: "",
                insured_certificate: "",
                insured_address: "",
                insured_code: "",
                insured_mobile: "",
                insured_fax: "",
                insured_count: "",
                insured:"",
                account: 0,
                compensate: "人民币50万元",
                compensates: "人民币50万元",
                compensate_num: "50",
                compensates_num: "50",
                placeholder: "详见附件清单表",
                period: "",
                ship_name: "",
                ship_type:"",
                pay_gross_ton: "",
                reg_port: "",
                construct_date: "",
                airworthiness_area: "",
                agreement: "",
                payment_agreement: "",
                statement: "",
                date:''

            },
            worktype_list: []
        }
    },
    created() {
        this.opera_type = this.$route.query.type
        this.query = this.$route.query.apply
        this.radio = this.$route.query.radio
        if (this.opera_type ==='addSmallPolicy'){
            this.setDefault()
            this.getInfo()
        }
        else{
            this.getSamllPolicy()
        }

        
    },
    methods: {
        cancelData() {
            this.$router.push({name: 'ApplyInsurance'})
         },

        getNowDate() {
            const timeOne = new Date()
            const year = timeOne.getFullYear()
            let month = timeOne.getMonth() + 1
            let day = timeOne.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day
            this.form.date = "日期：" + `${year}年${month}月${day}日`
            
            },

        setDefault() {
            if (this.query.small_rate === 1500) {
                if (this.radio === '1'){   
                    this.form.agreement = "□碰撞船舶、触碰码头责任：\n" +
                    "每次事故赔偿限额     /    ，累计赔偿限额     /    ，每次事故绝对免赔：     /   \n" +
                    "☑触碰桥梁责任： \n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整，每次事故绝对免赔： \n" +
                    "人民币5000元或核定损失金额的10%，两者以高者为准。\n" +
                    "□触碰水下电缆、渔网责任：\n" +
                    "每次事故赔偿限额     /     ，累计赔偿限额     /    ，每次事故绝对免赔：    /   \n" +
                    "□第三者人身伤亡责任：\n" +
                    "其中每人赔偿限额      /      ，投保人数    /     人，每次事故绝对免赔：    /   \n" +
                    "□火灾、爆炸责任：\n" +
                    "其中第三者财产损失每次事故赔偿限额    /        ，每次事故绝对免赔：     /   \n" +
                    "第三者人身伤亡每人赔偿限额        /    ，每次事故绝对免赔：      / \n" +
                    "□第三者污染责任：\n" +
                    "每次事故赔偿限额       /   ，累计赔偿限额     /    ，每次事故绝对免赔：  /   "
                    this.form.payment_agreement = "1.本保单承保触碰桥梁责任，年累计赔偿限额：人民币50万元，每次事故赔偿限额：人民币" +
                    "50万元 ，每次事故绝对免赔：人民币5000元或核定损失金额的10%，两者以高者为准。 \n" +
                    "2.本船已安装广东海事局名录下的内河船舶智能视频监控报警系统终端设备。\n" 
                    // "3.本保单共同被保险人为：" + this.query.insured
                }
                else if(this.radio === '2'){
                    this.form.agreement = "□碰撞船舶、触碰码头责任：\n" +
                    "每次事故赔偿限额     /    ，累计赔偿限额     /    ，每次事故绝对免赔：     /   \n" +
                    "☑触碰桥梁责任： \n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整，每次事故绝对免赔： \n" +
                    "人民币2万元或核定损失金额的10%，两者以高者为准。\n" +
                    "□触碰水下电缆、渔网责任：\n" +
                    "每次事故赔偿限额     /     ，累计赔偿限额     /    ，每次事故绝对免赔：    /   \n" +
                    "□第三者人身伤亡责任：\n" +
                    "其中每人赔偿限额      /      ，投保人数    /     人，每次事故绝对免赔：    /   \n" +
                    "□火灾、爆炸责任：\n" +
                    "其中第三者财产损失每次事故赔偿限额    /        ，每次事故绝对免赔：     /   \n" +
                    "第三者人身伤亡每人赔偿限额        /    ，每次事故绝对免赔：      / \n" +
                    "□第三者污染责任：\n" +
                    "每次事故赔偿限额       /   ，累计赔偿限额     /    ，每次事故绝对免赔：  /   "
                    this.form.payment_agreement = "1.本保单承保触碰桥梁责任，年累计赔偿限额：人民币50万元，每次事故赔偿限额：人民币" +
                    "50万元 ，每次事故绝对免赔：人民币2万元或核定损失金额的10%，两者以高者为准。 \n" 
                    // "2.本保单共同被保险人为：" + this.query.insured
                }
            
             
            }
            else if (this.query.small_rate === 3500) {
                if (this.radio === '1'){
                    this.form.agreement = "☑触碰桥梁责任：\n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" +
                    "☑触碰渔具、网具造成的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰人工养殖水生物、养殖物设施的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰电缆、光缆、管道及其在建时相关设施造成的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰市政、水利、供水、科研设施、船闸造成的直接损失：\n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。  "
                this.form.payment_agreement = "1、本保单年累计赔偿限额：人民币50万元，每次事故赔偿限额：人民币50万元 ，每次事故" +
                    "绝对免赔：人民币5000元或核定损失金额的10%，两者以高者为准。\n" +
                    "2、触碰桥梁责任：每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" +
                    "3、触碰渔具、网具造成的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额人民币50万元整。\n" +
                    "4、触碰人工养殖水生物、养殖物设施的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额人民币50万元整。\n" +
                    "5、触碰电缆、光缆、管道及其在建时相关设施造成的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "6、触碰市政、水利、供水、科研设施、船闸造成的直接损失：每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" +
                    "7、本船已安装广东海事局名录下的内河船舶智能视频监控报警系统终端设备。\n" 
                    // "8、本保单共同被保险人为：" + this.query.insured

                }
                else if (this.radio === '2'){
                    this.form.agreement = "☑触碰桥梁责任：\n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" +
                    "☑触碰渔具、网具造成的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰人工养殖水生物、养殖物设施的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰电缆、光缆、管道及其在建时相关设施造成的直接损失：\n" +
                    "每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "☑触碰市政、水利、供水、科研设施、船闸造成的直接损失：\n" +
                    "每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。  "
                this.form.payment_agreement = "1、本保单年累计赔偿限额：人民币50万元，每次事故赔偿限额：人民币50万元 ，每次事故" +
                    "绝对免赔：人民币2万元或核定损失金额的10%，两者以高者为准。\n" +
                    "2、触碰桥梁责任：每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" +
                    "3、触碰渔具、网具造成的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额人民币50万元整。\n" +
                    "4、触碰人工养殖水生物、养殖物设施的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额人民币50万元整。\n" +
                    "5、触碰电缆、光缆、管道及其在建时相关设施造成的直接损失：每次事故赔偿限额 人民币50万元整，累计赔偿限额 人民币50万元整。\n" +
                    "6、触碰市政、水利、供水、科研设施、船闸造成的直接损失：每次事故赔偿限额为人民币50万元整，累计赔偿限额为人民币50万元整。\n" 
                    // "7、本保单共同被保险人为：" + this.query.insured
                }
              

            }

            this.form.statement = "保险人已向本人交付《沿海内河船舶第三者责任保险条款》，并详细介绍了条款内容，特别是对保险合同中免除保险" +
                "人责任的条款和投保人、被保险人义务的内容做了明确说明，本人已知悉其涵义，同意投保并以此投保单作为订立保险合同的依据。"
            this.form.applicant_name = "广东中小船东互助发展中心（有限合伙）"
            this.form.applicant_address = "广州市黄埔区黄埔大道东974号608房"
            this.form.applicant_code = "510700"
            this.form.applicant_mobile = "020-82355093"
            this.form.account = "人民币 " + this.query.small_premium + " 元"
            let end_date = this.query.small_end_date
            let begin_date = this.query.small_begin_date
            this.form.ship_name = this.query.ship_name
            // this.form.pay_gross_ton = this.query.pay_gross_ton
            this.form.insured_name = this.query.insured
            this.form.id = this.query.id
            this.form.ship_type = this.query.ship_type
            this.form.insured = this.query.insured
            // this.form.pay_gross_ton = this.query.pay_gross_ton
            this.form.airworthiness_area = this.query.ship_airworthiness_area
            this.form.period = "自" + begin_date.split('-')[0] + "年" + begin_date.split('-')[1] + "月" + begin_date.split('-')[2] + "日零时起至" + end_date.split('-')[0] + "年" + end_date.split('-')[1] + "月" + end_date.split('-')[2] + "日二十四时止"
            this.getNowDate()
        },
        getInfo() {
            GetShipInfo({ 'ship': this.query.ship })
                .then(res => {
                    let result = res.result
                    // this.form.ship_type = result.ship_type
                    this.form.construct_date = result.construct_date
                    this.form.reg_port = result.reg_port
                    this.form.pay_gross_ton = result.gross_tonnage
                    // this.form.airworthiness_area = result.airworthiness_area
                })
                .catch(err => {
                    this.$error_message(err)
                })
        },
        getSamllPolicy(){
            smallPolicy(this.query)
                .then(res => {
                    this.form = res
                })
                .catch(err => {
                    this.$error_message(err)
                })
        },

        handleExport(file_type) {
            this.downloading = true
            this.downloadingText = '正在导出投保单，请稍等...'
            this.form.file_type = file_type
            exportAppForm(this.form, file_type)
                .then(res => {
                    let link = document.createElement('a')
                    link.style.display = 'none'

                    let blob = new Blob([res])
                    link.href = URL.createObjectURL(blob)

                    let ext_name = '.pdf'
                    if (file_type === 'word') {
                        ext_name = '.docx'
                    }
                    link.download = this.query.ship_name + "小桥梁险" + ext_name
                    document.body.appendChild(link)

                    link.click()
                    URL.revokeObjectURL(blob)
                    document.body.removeChild(link)
                    this.downloading = false
                })
                .catch(error => {
                    this.downloading = false

                })
        },
        handleSave() {
            this.downloading = true
            this.downloadingText = '正在生成投保单，请稍等...'
            saveAppform(this.form)
            .then(res => {
                this.$message.success(res)
                this.downloading = false
            })
            .catch(err => {
                this.downloading = false
            })
        }
    },
    mounted() {
    },
    beforeRouteLeave (to, from, next) {
        if (to.name != 'ApplyInsurance') {
          window.localStorage.removeItem('query')
        }
        next()
        }
}
</script>
  
<style lang="scss" scoped>
.eli-pingan {
    font-family: "Songti SC";
}

.eli-pingan-table {
    tr>td {
        width: 12%;
    }
}

.font-ht {
    font-family: "Heiti SC";
}
</style>
  